// removed by extract-text-webpack-plugin
module.exports = {"receipt-refund-reason":"app-components-receipt-invoices-RefundReason-__RefundReasonStyle___JCpx-","truncate-refund-reason":"app-components-receipt-invoices-RefundReason-__RefundReasonStyle___3qxHq"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/invoices/RefundReason/RefundReasonStyle.css
// module id = 2236
// module chunks = 0